var _defs, _g, _polyline, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurrender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2834.65 2834.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 20px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #58595b;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke-width: 100px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        fill: #f1f1f2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M829.79,1038.61s228.77-51.61,504.56,20.83c275.8,72.44,254.1,357.75,513.48,425.88,259.38,68.12,554.46-7.24,554.46-7.24l379.6-931.47s-295.08,75.37-554.46,7.24c-259.38-68.12-237.69-353.44-513.48-425.88-275.79-72.43-504.56-20.83-504.56-20.83l-166.04,407.44-213.56,524.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.79,1038.61s228.77-51.61,504.56,20.83c275.8,72.44,254.1,357.75,513.48,425.88,259.38,68.12,554.46-7.24,554.46-7.24l379.6-931.47s-295.08,75.37-554.46,7.24c-259.38-68.12-237.69-353.44-513.48-425.88-275.79-72.43-504.56-20.83-504.56-20.83l-166.04,407.44-213.56,524.03Z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "1194.37 57.44 1032.52 451.74 823.88 960.02 661.56 1355.47 452.83 1863.72 290.42 2259.14 82.26 2766.28"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1194.37 57.44 1032.52 451.74 823.88 960.02 661.56 1355.47 452.83 1863.72 290.42 2259.14 82.26 2766.28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurrender);
export default __webpack_public_path__ + "static/media/surrender.5db4c98abd23e3250ea256134e77ecb5.svg";
export { ForwardRef as ReactComponent };